(() => {
  const debounce = (fn, wait = 180) => {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn(...args), wait);
    };
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-fb-header]').forEach((header) => {
      if (header.dataset.fbPredictiveReady === 'true') return;
      header.dataset.fbPredictiveReady = 'true';

      const input = header.querySelector('[data-fb-search-input]');
      const results = header.querySelector('[data-fb-predictive-results]');
      const searchPanel = header.querySelector('[data-fb-search]');
      const closeButton = header.querySelector('[data-fb-search-close]');

      if (!input || !results) return;

      let controller = null;
      let requestId = 0;

      const clear = () => {
        results.innerHTML = '';
        results.hidden = true;
        results.classList.remove('is-loading');
        input.setAttribute('aria-expanded', 'false');
      };

      const load = debounce(async () => {
        const query = input.value.trim();
        if (query.length < 2) {
          clear();
          return;
        }

        controller?.abort();
        controller = new AbortController();
        const currentRequest = ++requestId;
        results.hidden = false;
        results.classList.add('is-loading');

        const rootUrl = window.Shopify?.routes?.root || '/';
        const url =
          `${rootUrl}search/suggest?q=${encodeURIComponent(query)}` +
          '&resources[type]=product,collection' +
          '&resources[limit]=6' +
          '&section_id=predictive-search';

        try {
          const response = await fetch(url, {
            signal: controller.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = await response.text();
          if (currentRequest !== requestId) return;

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');

          results.innerHTML = section?.innerHTML || '';
          results.hidden = false;
          results.classList.remove('is-loading');
          input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error?.name === 'AbortError') return;
          console.warn('[Forever Bloom] predictive search:', error);
          clear();
        }
      }, 180);

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.addEventListener('input', load);

      closeButton?.addEventListener('click', clear);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') clear();
      });

      document.addEventListener('click', (event) => {
        if (!searchPanel?.contains(event.target) && !header.querySelector('[data-fb-search-toggle]')?.contains(event.target)) {
          clear();
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
